import axios from "axios";
import React, { useEffect, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

const AddUniversityAssignmentPricing = () => {
  const [universities, setUniversities] = useState([]);
  const [universityId, setUniversityId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [courses, setCourses] = useState([]);
  const [semesterId, setSemesterId] = useState("");
  const [semesters, setSemesters] = useState([]);
  const [price, setPrice] = useState();

  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const handleAddPrice = () => {
    navigate("/assignment-pricing/add-university-assignment-pricing");
  };
  const handleViewAllPrice = () => {
    navigate("/assignment-pricing/all-university-assignment-pricing");
  };
  const handleGoBack = () => {
    navigate("/assignment-pricing");
  };
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/universities`)
      .then((response) => {
        const universitiesData = response.data?.data || [];
        setUniversities(universitiesData);
      })
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    if (universityId) {
      axios
        .get(`${API_BASE_URL}/all-courses/${universityId}`)
        .then((response) => {
          const coursesData = response.data?.data || [];
          setCourses(coursesData);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [universityId]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/semesters`)
      .then((response) => {
        const semesterData = response.data?.data || [];
        setSemesters(semesterData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const payload = {
    courseId,
    semesterId,
    price,
    type: "university",
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post(`${API_BASE_URL}/admin/pricing/assignment`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((result) => {
        console.log(result);
        alert("University Assignment Price Added.");
        navigate("/assignment-pricing/all-university-assignment-pricing");
      })
      .catch((error) => {
        console.log(error);
        alert("Error while adding price.");
      });
  };

  return (
    <div id="exam-college-notes-inner-wrapper">
      <div className="main-header">
        <BiArrowBack
          onClick={handleGoBack}
          className="left-arrow-icon"
          style={{
            cursor: "pointer",
            marginLeft: "10px",
            fontSize: "25px",
            color: "#000", // Customize the color as needed
          }}
        />
        <div className="exam-header-div">
          <h5>University Assignment Pricing</h5>
          <div className="exam-btn-group">
            <button className="addNewNoteBtn" onClick={handleAddPrice}>
              + Add Price
            </button>
            <button className="viewAllNotesBtn" onClick={handleViewAllPrice}>
              All Price
            </button>
          </div>
        </div>

        <div className="allform-container" id="form">
          <h4 className="note-detail">Price Details</h4>
          <form
            onSubmit={handleSubmit}
            encType="multipart/form-data"
            className="note-detail-form"
          >
            <div className="new-chapter-form-group">
              <label className="new-chapter-label">Select University</label>
              <select
                className="new-chapter-dropdown"
                value={universityId}
                onChange={(e) => setUniversityId(e.target.value)}
                required
              >
                <option value="">-Select University-</option>
                {universities.map((universitie, idx) => (
                  <option key={idx} value={universitie._id}>
                    {universitie.universityName}
                  </option>
                ))}
              </select>
            </div>

            <div className="new-chapter-form-group">
              <label className="new-chapter-label">Course Name</label>
              <select
                className="new-chapter-dropdown"
                value={courseId}
                onChange={(e) => setCourseId(e.target.value)}
                required
              >
                <option value="">-Select Course-</option>
                {courses.map((course, idx) => (
                  <option key={idx} value={course._id}>
                    {course.courseName}
                  </option>
                ))}
              </select>
            </div>

            <div className="new-chapter-form-group">
              <label className="new-chapter-label">Semester</label>
              <select
                className="new-chapter-dropdown"
                value={semesterId}
                onChange={(e) => setSemesterId(e.target.value)}
                required
              >
                <option value="">-Select Semester-</option>
                {semesters.map((semester, idx) => (
                  <option key={idx} value={semester._id}>
                    {semester.semesterName}
                  </option>
                ))}
              </select>
            </div>

            <div className="input-group">
              <label className="label">Price</label>
              <input
                type="text"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                placeholder="Enter Price"
                required
              />
            </div>

            <div className="form2-btns">
              <button className="btn-save" type="submit">
                Save
              </button>
              <button className="btn-cancel" type="button">
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddUniversityAssignmentPricing;
